import { IdentityProvider } from 'types/sessionsTypes';

export const PROVIDER_ACCESS: IdentityProvider = 'Access';
